import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { auth } from '../../../Auth';
import moment from 'moment';
import DB from '../../../DAL/DB';
import { useDBSubscribe } from '../../../effects';
import { TYPES } from '../../reducer';

const calendar = new DB.Calendars();

export default function useGetAvailability() {
  const dispatch = useDispatch();
  
  // We need the current inspector ID to trigger re-fetches or updates if the user changes
  const inspectorId = useSelector(state => state.inspector?.id);

  // use now as a default value
  const [now] = useState(moment(new Date()));
  const date = moment(now);

  const filters = [];
  if (auth.sunkaizenUser.type === 'field-user') {
    filters.push([`data.id`, `==`, auth.sunkaizenUser.id]);
  }

  date.month(date.month() - 6);
  filters.push(['date', '>', date.toDate()]);

  date.month(date.month() + 12);
  filters.push(['date', '<', date.toDate()]);

  // Hook into your DB subscription logic
  const availability = useDBSubscribe(calendar, { filters });

  // Convert array to map
  const availabilityMap = {};
  for (let avail of availability) {
    availabilityMap[avail.id] = avail;
  }

  // Create a unique key to detect changes in keys or current inspector
  const changed = [...new Set(Object.keys(availabilityMap)), inspectorId].join(',');

  useEffect(
    function () {
      dispatch({ 
        type: TYPES.AVAILABILITY, 
        payload: availabilityMap 
      });
    },
    [changed, dispatch] 
  );
}